import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';
import { EcommerceRoutes } from './ecommerce.routing';

import {MatPaginatorModule} from '@angular/material/paginator';
import { NgxPermissionsModule } from 'ngx-permissions';
import { AddcategoryComponent } from './addcategory/addcategory.component';
import { ViewcategoryComponent } from './viewcategory/viewcategory.component';
import { ProductlistComponent } from './productlist/productlist.component';


@NgModule({
  imports: [ 
    CommonModule,
    RouterModule.forChild(EcommerceRoutes),
    NgbModule,
    FormsModule,
    MatPaginatorModule,
    NgxPermissionsModule.forChild(),
  ],
  declarations: [AddcategoryComponent, ViewcategoryComponent, ProductlistComponent]
})

export class EcommerceModule {
}



// WEBPACK FOOTER //
// C:/projects/wct-nextias-ui/src/app/ecommerce/ecommerce.module.ts